import {Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss';

import {CloseButton, BackButton} from '/chat/src/components/Buttons';
import HeaderRightToolBelt from '/chat/src/components/Header/Toolbelt/RightSide'
import SearchIcon from '/chat/src/components/SVGImages/SearchIcon'

import Customization from '/chat/src/redux/model/customization/model';
import Company from '/chat/src/redux/model/company/model';
import System from '/chat/src/redux/model/system/model'



class HelpDeskHeader extends Component {
    constructor(props) {
        super(props);
        this._goBack = this._goBack.bind(this);
    }

    componentDidMount() {
        //User hits refresh while searching.
        if (this.props.route === 'HelpDeskSearch' && this.props.searchInput === '') {
            this.props.dispatch(System.setHelpDeskRoute('HelpDesk'));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchInput === '' && this.props.searchInput !== '') {
            this.props.dispatch(System.setHelpDeskRoute('HelpDeskSearch'));
        } else if (prevProps.searchInput !== '' && this.props.searchInput === '') {
            this.props.dispatch(System.setHelpDeskRoute('HelpDesk'));
        }
    }

    _goBack() {
        const route  = this.props.route;
        const activeCategory = this.props.activeCategory;
        switch(route) {
            case 'HelpDeskArticle':
                //activeCategory === -1 implies no category set, it entered
                //article through search results.
                if (activeCategory === '-1') {
                    this.props.dispatch(System.setHelpDeskRoute('HelpDeskSearch'))
                } else {
                    this.props.dispatch(System.setHelpDeskRoute('HelpDeskFocused', activeCategory))
                }
                break;
            case 'HelpDeskSearch':
                this.props.dispatch(System.helpDeskSearch(''))
                break;
            case 'HelpDeskFocused':
            default:
                this.props.dispatch(System.setHelpDeskRoute('HelpDesk'))
                break;
        }
    }

    _renderSearchInput() {
        return (
            <div style={{backgroundColor: this.props.color}} className={style.InputWrapper}>
                <input
                    type='text'
                    placeholder={this.props.language.get("SearchQuestion")}
                    class={style.InputSearch}
                    style={{border: `1px solid ${this.props.color}`}}
                    value={this.props.searchInput}
                    onInput={(e) => this.props.dispatch(System.helpDeskSearch(e.target.value))}/>
                <div>
                    <div className={style.SearchIcon}>
                    <SearchIcon color={this.props.color} />
                    </div>
                </div>
            </div>
        )
    }


    render() {
        const route = this.props.route
        const showBackBtn = route === 'HelpDeskFocused' || route === 'HelpDeskArticle' || route === 'HelpDeskSearch';
        const showSearchInput = route === 'HelpDeskFocused' || route === 'HelpDesk' || route === 'HelpDeskSearch';
        return (
            <div style={{backgroundColor: this.props.color}}>
                <div className={style.BackButtonWrapper}>
                    {showBackBtn && <BackButton callback={this._goBack}/>}
                </div>
                <HeaderRightToolBelt>
                    <CloseButton/>
                </HeaderRightToolBelt>
                <div className={style.HeaderContainer}>
                    <div className={style.CompanyName}> {this.props.companyName} </div>
                    <div className={style.HelpDesk}> Helpdesk </div>
                    {showSearchInput && this._renderSearchInput()}
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const color = Customization.getColor(state);
    const companyName = Customization.getCompanyDisplayName(state)
    const fullRoute = System.getHelpDeskRoute(state).split(';');
    const route = fullRoute[0];
    const activeCategory = fullRoute[1];
    const language = Customization.getLanguage(state);
    const searchInput = System.getSearchInput(state)
    return {
        color: color,
        language: language,
        companyName: companyName,
        route: route,
        activeCategory: activeCategory,
        searchInput: searchInput
    }
}

export default connect(mapStateToProps)(HelpDeskHeader);



// WEBPACK FOOTER //
// ./routes/HelpDesk/Header/Header.js